<script setup lang="ts">
import { CloseCircleIcon } from '@fond-of/satch-icons'

defineProps<{
  closeIcon?: boolean
}>()

const emits = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <div
    class="bg-green-light text-green font-sans-semi-bold flex px-5 py-[0.563rem] text-sm"
  >
    <div class="w-full">
      <slot />
    </div>

    <CloseCircleIcon
      v-if="closeIcon"
      class="text-green md:h-7.5 md:w-7.5 h-8 w-8 min-w-[2rem] cursor-pointer md:min-w-[1.875rem]"
      @click="emits('close')"
    />
  </div>
</template>
